// Module
var code = "<template class=\"comp-icon\"> <slot></slot> </template>";
// Exports
module.exports = code;